import { useLanguage } from '@/context/LanguageContext';

export default function Footer() {
  const { lang, t } = useLanguage();

  return (
    <footer className="py-12 bg-[#050505] border-t border-white/5" data-testid="footer">
      <div className="px-6 md:px-12 lg:px-24 max-w-[1600px] mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center md:items-start gap-2">
            <span className="font-heading text-lg tracking-tight text-[#F5F5F0]">
              <a href="https://villa259.com" className="hover:text-[#C8B598] transition-colors">Villa<span className="text-[#C8B598]">259</span>.com</a>
            </span>
            <p className="text-xs text-[#9CA3AF]">{t('footer.project')}</p>
          </div>
          <div className="flex flex-col items-center md:items-end gap-2">
            <p className="text-xs text-[#9CA3AF]">
              &copy; {new Date().getFullYear()} <a href="https://villa259.com" className="hover:text-[#C8B598] transition-colors">Villa259.com</a>. {t('footer.rights')}
            </p>
            <p className="text-[10px] text-[#9CA3AF]/60">
              {lang === 'en' ? 'Architecture by' : 'Arquitectura por'}{' '}
              <a href="https://www.ismaelmerida.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C8B598] transition-colors underline underline-offset-2">
                Ismael M&eacute;rida
              </a>
            </p>
            <p className="text-[10px] text-[#9CA3AF]/60 italic">
              {t('footer.disclaimer')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
